import { useDeviceType } from '@cian/ui-kit';

export const useIsDesktop = (): boolean => {
  return useDeviceType() === 'desktop';
};
